module.exports = __webpack_public_path__ + "img/hero.b2467620.svg";